import { BusinessCell } from 'modules/Common/Details';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = [
  'has_ftl_shipper_order',
  'has_xdock_shipper_order',
  'has_recovering_shipper',
  'service_type',
  'is_lh_express',
];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { journeyId, selectors } = props || {};
    const { getJourneyFields } = selectors || {};
    const {
      has_ftl_shipper_order,
      has_xdock_shipper_order,
      has_recovering_shipper,
      service_type,
      is_lh_express,
    } = getJourneyFields ? getJourneyFields(state, journeyId, fields) : {};

    return {
      isFtl: has_ftl_shipper_order,
      isXDock: has_xdock_shipper_order,
      serviceType: service_type,
      isRecovering: has_recovering_shipper,
      isLHExpress: is_lh_express,
    };
  })
);

export default enhance(BusinessCell);
